<template>
  <div v-if="isReady" class="message-sent-graph d-flex flex-column">
    <h5 class="message-sent-graph--title">{{ title }}</h5>
    <div class="message-sent-graph--body">
      <div id="messageSentGraph"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ApexCharts from "apexcharts";
import { mapGetters } from "vuex";

export default {
  name: "MessageSentGraph",
  props: {
    graphData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isReady: true,
      chart: null,
      options: {
        series: [],
        chart: {
          width: "100%",
          height: "400px",
          type: "area",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: "3",
        },
        grid: {
          row: {
            colors: ["transparent"],
          },
        },
        legend: {
          position: "top",
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },
  computed: {
    ...mapGetters("user", ["isDarkMode"]),
    title() {
      return "Messages Sent";
    },
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      this.chart = new ApexCharts(document.querySelector("#messageSentGraph"), {
        ...this.options,
      });
      this.chart.render();
    },
    updateChart(graphData) {
      const { data } = graphData;
      if (data && data.length > 0) {
        const series = [
          {
            name: "Messages Sent",
            data: data.map((item) => item.count),
          },
        ];
        const options = {
          ...this.options,
          series,
          xaxis: {
            categories: [...data.map((item) => item.time)],
          },
        };

        if (this.isDarkMode) {
          options["theme"] = { mode: "dark" };
        }
        setTimeout(() => {
          this.chart.updateSeries(series);
          this.chart.updateOptions(options);
        }, 100);
      }
    },
  },
  watch: {
    graphData: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal || {}) !== JSON.stringify(oldVal || {})) {
          this.updateChart(newVal);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
      this.isReady = false;
    }
  },
};
</script>

<style lang="scss">
.message-sent-graph {
  width: 100%;
  gap: 0.5rem;
  &--title {
    margin: 0;
    height: 20px;
    line-height: 20px;
  }
}
</style>
